module.exports = __webpack_public_path__ + "img/searchProfile.1a5dc346.png";